export default {
  meta: {
    title: '表单配置'
  }
};
